module.exports = __webpack_public_path__ + "img/TW_VodaPinsArtboard 20.2339ab31.png";